import React, { useState, useEffect } from "react";
import './EntryLevelLearning.css'
import '../function-components/HomeContent.css'
import './LearningHighlights.css'
import MenuNavbar from '../function-components/MenuNavbar';
import Floaticons from '../function-components/Floaticons';

function LearningHighlights() {
  const [displaySkill, setDisplaySkill] = useState("news-events");
  return (
    <>
      <div className="banner-container">
        <img src="images/Banner1.png" alt="banner" className="banner-img" />
        <MenuNavbar />
      </div>
      <Floaticons />

      <div className="Network_tab_cont" id="learningHighlights">
        <a className={displaySkill === "news-events" ? 'Network_tab_tier-cap-active' : 'Network_tab_tier-cap-inactive'} onClick={() => setDisplaySkill('news-events')} href='#techexpressway'>News and Events</a>
        <a className={displaySkill === "security-learning" ? 'Network_tab_tier-mand-active' : 'Network_tab_tier-mand-inactive'} onClick={() => { setDisplaySkill('security-learning'); }} href='#campuscollaboration'>Security Learning metrics</a>
      </div>

      <div className="Network_skill_tab">
        {displaySkill === 'news-events' ? <div className="Network_skill_tile-container">
          <div className="news-container">
            <div className="news">
              {/* <h2>News and Events</h2> */}
              <h1>Coming Soon!</h1>
            </div>
          </div>
        </div> : ""}
        {
          displaySkill === "security-learning" ? <h1>Coming Soon!</h1> : ""
        }
      </div>
    </>
  )
}

export default LearningHighlights;